import request from '@/utils/request'
import qs from 'qs'

export function getBookingGroupListApi(query) {
  return request({
    url: '/booking-service/v1/booking-group/list',
    method: 'get',
    params: query,
    // paramsSerializer: { indexes: true }
    paramsSerializer: query => {
      return qs.stringify(query, { arrayFormat: 'repeat' })
    }
  })
}

export function fetchList(query) {
  return request({
    url: '/vue-element-admin/article/list',
    method: 'get',
    params: query
  })
}

export function getBookingGroupAvailableRoomLevelListApi(query) {
  return request({
    url: '/booking-service/v1/booking-group/available-room-level-list',
    method: 'get',
    params: query
  })
}
